module.exports = __webpack_public_path__ + "static/media/NavHeader@2x.1571e8b1.jpg";